import React, { useState } from 'react';
import { Chip, CircularProgress, makeStyles } from '@material-ui/core';
import {
  COLORS, PERIODS, PERIOD_SUFFIX, getDateRange,
} from './data';
import resumenRequest from '../../../requests/api/resume';

const useStyles = makeStyles(() => ({
  panel: {
    background: 'white',
    borderRadius: 14,
    border: '1px solid rgba(0,0,0,0.06)',
    overflow: 'hidden',
  },
  header: {
    padding: '12px 16px 10px',
    borderBottom: `1px solid ${COLORS.mist}`,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  title: {
    fontSize: 13.5,
    fontWeight: 700,
    color: COLORS.ink,
  },
  chips: { display: 'flex', gap: 4, flexWrap: 'wrap' },
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    borderBottom: '1px solid #f2f5f7',
    gap: 10,
    '&:last-child': { borderBottom: 'none' },
  },
  rank: {
    fontSize: 11,
    fontWeight: 800,
    color: COLORS.blue,
    width: 18,
    flexShrink: 0,
  },
  wrap: { flex: 1, minWidth: 0 },
  name: {
    fontSize: 12.5,
    fontWeight: 600,
    color: COLORS.ink,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginBottom: 3,
  },
  barBg: {
    height: 4,
    background: COLORS.mist,
    borderRadius: 10,
    overflow: 'hidden',
  },
  barFill: {
    height: '100%',
    background: `linear-gradient(90deg,${COLORS.blue},#5CC8EE)`,
    borderRadius: 10,
  },
  amount: {
    fontSize: 12,
    fontWeight: 700,
    color: COLORS.ink,
    textAlign: 'right',
    minWidth: 60,
  },
  units: {
    fontSize: 10.5,
    color: COLORS.slate,
    fontWeight: 400,
  },
  loadingWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 16px',
  },
}));

export default function TopProductsPanel({ productos: initialProductos, clientId }) {
  const classes = useStyles();
  const [period, setPeriod] = useState('today');
  const [productos, setProductos] = useState(initialProductos);
  const [loading, setLoading] = useState(false);

  const handlePeriodChange = async (key) => {
    if (key === period) return;
    setPeriod(key);
    const { startDate, endDate } = getDateRange(key);
    setLoading(true);
    try {
      const response = await resumenRequest.getTopProducts(clientId, startDate, endDate);
      if (response.success) setProductos(response.data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.panel}>
      <div className={classes.header}>
        <div className={classes.titleRow}>
          <span className={classes.title}>
            Lo más vendido — {PERIOD_SUFFIX[period]}
          </span>
        </div>
        <div className={classes.chips}>
          {PERIODS.map((p) => (
            <Chip
              key={p.key}
              label={p.label}
              size="small"
              onClick={() => handlePeriodChange(p.key)}
              color={period === p.key ? 'primary' : 'default'}
              variant={period === p.key ? 'default' : 'outlined'}
            />
          ))}
        </div>
      </div>
      {loading ? (
        <div className={classes.loadingWrap}>
          <CircularProgress size={22} />
        </div>
      ) : (
        productos && productos.map((p) => (
          <div key={p.rank} className={classes.row}>
            <span className={classes.rank}>#{p.rank}</span>
            <div className={classes.wrap}>
              <div className={classes.name}>{p.name}</div>
              <div className={classes.barBg}>
                <div className={classes.barFill} style={{ width: `${p.pct}%` }} />
              </div>
            </div>
            <div className={classes.amount}>
              {p.amount}<br />
              <span className={classes.units}>{p.units}</span>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
